import { createContext } from 'react'

export const CollapsibleContainerContext = createContext({})
